/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import InterventionListCard, { InterventionListQuery } from '../intervention/InterventionListCard'
import { Container } from '@mantine/core'
import { getInterventionCreateLink } from '../../lib/links/interventionLinks'
import Page from '../../../../client/js/components/Page'
import LeaseBreadcrumb from './LeaseBreadcrumb'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'

function LeaseInterventionListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const leaseId = parseInt(params.id, 10)
  const lease = useRouteLoaderData<Lease>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: InterventionListQuery = useMemo(() => ({
    ...searchParams,
    leaseId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'interventions',
    defaultMessage: 'Interventions'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <LeaseBreadcrumb
          lease={lease}
          title={title}
        />

        <InterventionListCard
          createLink={getInterventionCreateLink({
            estateId: lease?.estateId,
            leaseId
          })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default LeaseInterventionListPage
